import { WidgetConfiguration } from "../../gen/witbooking/backoffice/loyalty/brand/v1/loyalty_brand_api_pb";
import { BrandFormData } from "./types";

/**
 * Maps form data to WidgetConfiguration protobuf message
 * @param data Form data containing widget fields
 * @returns WidgetConfiguration instance or null if widget is not enabled or fields are missing
 */
export const mapFormDataToWidgetConfiguration = (
  data: BrandFormData
): WidgetConfiguration | null => {
  // Only create configuration if widget is enabled and all fields are provided
  if (!data.widgetLoyalty || !data.widgetUrl || !data.idTierAgency || !data.idTierCompany) {
    return null;
  }

  const widgetConfig = new WidgetConfiguration();
  widgetConfig.setUrl(data.widgetUrl);
  widgetConfig.setTierAgencyId(data.idTierAgency);
  widgetConfig.setTierCompanyId(data.idTierCompany);

  return widgetConfig;
};

/**
 * Extracts widget configuration data from WidgetConfiguration protobuf message
 * @param widgetConfig WidgetConfiguration protobuf instance
 * @returns Object with widget fields or empty strings if not provided
 */
export const mapWidgetConfigurationToFormData = (
  widgetConfig: WidgetConfiguration | undefined
): Pick<BrandFormData, "widgetUrl" | "idTierAgency" | "idTierCompany"> => {
  return {
    widgetUrl: widgetConfig?.getUrl() || "",
    idTierAgency: widgetConfig?.getTierAgencyId() || "",
    idTierCompany: widgetConfig?.getTierCompanyId() || "",
  };
};

/**
 * Checks if widget configuration has all required fields
 * @param widgetConfig WidgetConfiguration protobuf instance
 * @returns true if all three fields are present, false otherwise
 */
export const hasCompleteWidgetConfiguration = (
  widgetConfig: WidgetConfiguration | undefined
): boolean => {
  return !!(
    widgetConfig &&
    widgetConfig.getUrl() &&
    widgetConfig.getTierAgencyId() &&
    widgetConfig.getTierCompanyId()
  );
};
